import ProjectServices from "../Services/ProjectServices";

export const GetProjectRecords = async (data) => {
  let response = ProjectServices.GetProjectRecords(data);
  return response;
}